import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useUrlFilters } from '~/features/filter';

import { ivideonDealerFilterFields } from './fields';

export interface IvideonDealerFilterValues {
  ids?: string;
  dealerName?: string;
  address?: string;
  ivideonOwnerName?: string;
  code?: string;
  category?: string;
  city?: string;
  ivideonAuthorized?: string;
  serviceAccept?: string;
  saleAccept?: string;
  checkStatus?: string;
  status?: string;
  extendedForNextYear?: string;
}

export const useIvideonDealerUrlFilters = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => ivideonDealerFilterFields(t), [t]);

  return useUrlFilters(fields);
};

export const useIvideonDealerFilterValues = (): IvideonDealerFilterValues => {
  const { values } = useIvideonDealerUrlFilters();

  return useMemo<IvideonDealerFilterValues>(() => {
    const val = values as Record<string, unknown>;

    return {
      ids: (val.ids as string) || undefined,
      dealerName: (val.dealerName as string) || undefined,
      address: (val.address as string) || undefined,
      ivideonOwnerName: (val.ivideonOwnerName as string) || undefined,
      code: (val.code as string) || undefined,
      category: (val.category as string) || undefined,
      city: (val.city as string) || undefined,
      ivideonAuthorized: (val.ivideonAuthorized as string) || undefined,
      serviceAccept: (val.serviceAccept as string) || undefined,
      saleAccept: (val.saleAccept as string) || undefined,
      checkStatus: (val.checkStatus as string) || undefined,
      status: (val.status as string) || undefined,
      extendedForNextYear: (val.extendedForNextYear as string) || undefined,
    };
  }, [values]);
};
